import { Link } from "@tanstack/react-router";

import { useAuth0, useMemberLogin } from "@/integrations/fc/auth0";

type Props = { onClick: () => void };

const BUTTON_CLASS =
  "bg-primary px-8 py-3 fc-body text-primary-foreground transition-opacity hover:opacity-85 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent";

/** Reveals events hidden by full-row trimming; shown to signed-in members only. */
export function LoadMoreButton({ onClick }: Props) {
  return (
    <div className="mt-12 flex justify-center">
      <button type="button" onClick={onClick} className={BUTTON_CLASS}>
        Load More
      </button>
    </div>
  );
}

/**
 * "Load More" teaser leading to the full meetings list. Members go straight
 * there; guests sign in first and land on the expanded list afterwards.
 */
export function LoadMoreMeetingsLink({ className }: { className: string }) {
  const { isAuthenticated } = useAuth0();
  const login = useMemberLogin();
  return isAuthenticated ? (
    <Link to="/meetings" search={{ more: 1 }} className={className}>
      Load More
    </Link>
  ) : (
    <button type="button" onClick={() => login("/meetings?more=1")} className={className}>
      Load More
    </button>
  );
}
